import { Box, Typography, useTheme } from '@mui/material';
import image1 from '../../assets/other/auth-image-1.png';
import image2 from '../../assets/other/auth-image-2.png';
import image3 from '../../assets/other/auth-image-3.png';
import { useLocation } from 'react-router-dom';

const RightSideDataForLogin = [
    {
        imageSrc: image1,
        heading: 'Service Management',
        subheading: 'Handle the day-to-day details of your PRIME services',
        list: ['View real-time service status updates', 'Update payment information', 'Download invoices and billing history', 'Access and download entity documents'],
    },
    // {
    //     imageSrc: image2,
    //     heading: 'PRIME+ Services',
    //     subheading: 'Included with every LLC',
    //     list: ['Instant bank account application', 'Highly discounted operating agreement', 'Express doc filing'],
    // },
    {
        imageSrc: image3,
        heading: 'Guidance & Support',
        subheading: 'Stay on track with clear direction and direct help.',
        list: ['View important next steps for services', 'Access educational resources', 'Track assigned tasks and progress', 'Request support and additional services'],
    },
];
const RightSideDataForOtp = [
    {
        imageSrc: image1,
        heading: 'Service Management',
        subheading: 'Handle the day-to-day details of your PRIME services',
        list: ['View real-time service status updates', 'Update payment information', 'Download invoices and billing history', 'Access and download entity documents'],
    },
    // {
    //     imageSrc: image2,
    //     heading: 'PRIME+ Services',
    //     subheading: 'Included with every LLC',
    //     list: ['Instant bank account application', 'Highly discounted operating agreement', 'Express doc filing'],
    // },
    {
        imageSrc: image3,
        heading: 'Guidance & Support',
        subheading: 'Stay on track with clear direction and direct help.',
        list: ['View important next steps for services', 'Access educational resources', 'Track assigned tasks and progress', 'Request support and additional services'],
    },
];

const AuthRightSideUI = () => {
    const location = useLocation();
    const theme = useTheme();

    console.log('location', location);

    let currentData = [...RightSideDataForLogin];

    if (location.pathname?.includes('/email-otp')) {
        currentData = [...RightSideDataForOtp];
    }

    return (
        <Box>
            <Typography
                component={'h1'}
                variant="heading1"
                color={'text.primary'}
                fontSize={{
                    xs: theme.typography.customFontSize.xxxLarge,
                    sm: theme.typography.customFontSize.verylarge,
                }}
                fontFamily='"Barlow Condensed", sans-serif'
            >
                Your hub for long-term business health
            </Typography>{' '}
            <Typography
                component={'p'}
                variant="subHeading"
                color={'text.secondary'}
                fontSize={{
                    xs: theme.typography.customFontSize.medium,
                    sm: theme.typography.customFontSize.large,
                }}
                marginTop={{
                    xs: theme.typography.generic.xxSmall,
                }}
                // lineHeight='140%'
            >
                See what you can do with your <b style={{ fontWeight: '800' }}>PRIME</b>360 account.
            </Typography>
            <Box
            //  display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'} width={'100%'}
            >
                {currentData.map((cItem, key) => (
                    <Box display={'flex'} key={key} marginTop={'40px'}>
                        <Box marginRight={'1rem'}>
                            <img src={cItem.imageSrc} height={100} width={100} alt="image-1" />
                        </Box>
                        <Box color={'text.secondary'}>
                            <Typography component={'p'} variant="paraText1" color={'text.primary'}>
                                {cItem.heading}
                            </Typography>
                            <Typography component={'p'} color={'secondary'} variant="paraText2">
                                {cItem.subheading}
                            </Typography>
                            <Box component={'ul'} marginLeft={'2rem'}>
                                {cItem.list.map((clistItem) => (
                                    <li>
                                        <Typography color={'secondary'}>{clistItem}</Typography>
                                    </li>
                                ))}
                            </Box>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default AuthRightSideUI;
